import React from 'react';
import { Chip, TableCell, TableRow } from '@mui/material';
import { NavLink } from 'react-router-dom';
import { ROUTES } from 'module/navigation/enums/routes.enums';
import { formatDateTime12Hour } from 'shared/utils/dateUtils';
import EmployeeWidgetCard from './EmployeeWidgetCard';
import {
	formatChecklistDateTimeFromAPI,
	getChecklistAssignedDisplay,
	getChecklistOwnerName,
} from '../utils/checklistWidgetDisplay';

interface ChecklistScheduleEvent {
	id: number;
	checklistTemplate?: { label?: string; type?: string };
	scheduledDate: string;
	scheduledDateFormatted?: string;
	scheduledTimeFormatted?: string;
	scheduledTime?: string;
}

interface EmployeeChecklistWidgetProps {
	loading: boolean;
	items: ChecklistScheduleEvent[];
}

const EmployeeChecklistWidget = ({ loading, items }: EmployeeChecklistWidgetProps) => (
	<EmployeeWidgetCard
		title="My Checklist"
		loading={loading}
		colSpan={4}
		emptyMessage="No outstanding checklists"
		isEmpty={items.length === 0}
		header={
			<TableRow>
				<TableCell>Checklist Name</TableCell>
				<TableCell>Assigned</TableCell>
				<TableCell>Owner</TableCell>
				<TableCell>Checklist Due</TableCell>
			</TableRow>
		}
	>
		{items.map((item) => (
			<TableRow key={item.id} className="employee-widget-clickable-row">
				<TableCell>
					<NavLink to={ROUTES.CHECKLIST} className="employee-widget-link">
						{item.checklistTemplate?.label || 'Unknown Template'}
					</NavLink>
				</TableCell>
				<TableCell>{getChecklistAssignedDisplay(item)}</TableCell>
				<TableCell>{getChecklistOwnerName(item.checklistTemplate?.type)}</TableCell>
				<TableCell>
					{item.scheduledDateFormatted && item.scheduledTimeFormatted
						? formatChecklistDateTimeFromAPI(
								item.scheduledDateFormatted,
								item.scheduledTimeFormatted,
							)
						: formatDateTime12Hour(item.scheduledDate, item.scheduledTime)}
				</TableCell>
			</TableRow>
		))}
	</EmployeeWidgetCard>
);

export default EmployeeChecklistWidget;
